import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="min-h-screen w-full bg-[#0f1629] relative overflow-hidden" data-id="element-102">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0f1629] via-[#0f1629]/95 to-[#1a2342]" data-id="element-103" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20 md:pt-24 md:pb-32" data-id="element-104">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-105">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-106">
            <h1 className="font-['Playfair_Display'] text-4xl sm:text-5xl lg:text-6xl font-bold text-[#f0ebe3] leading-tight mb-6" data-id="element-107">
              Detén la Obsesión:{' '}
              <span className="text-[#c9a96e]" data-id="element-108">El Protocolo de 72 Horas</span>{' '}
              para Recuperar tu Dignidad
            </h1>

            <p className="text-lg sm:text-xl text-[#d4a574] font-['Playfair_Display'] italic mb-8 leading-relaxed" data-id="element-109">
              Para la mujer que no puede dejar de revisar su teléfono y siente
              que su valor personal depende de una respuesta que no llega.
            </p>

            {/* Opening Hook */}
            <div className="bg-[#1a2342]/60 border-l-4 border-[#c9a96e] p-6 rounded-r-lg mb-8" data-id="element-110">
              <p className="text-[#f0ebe3]/90 leading-relaxed mb-4" data-id="element-111">
                <span className="text-[#c9a96e] font-semibold" data-id="element-112">
                  Son las 11:45 PM.
                </span>{' '}
                Tu pantalla brilla en la oscuridad. Has revisado su "última vez"
                diez veces en la última hora y analizas cada palabra de su
                última historia como si fuera un mensaje en clave.
              </p>
              <p className="text-[#f0ebe3]/90 leading-relaxed mb-4" data-id="element-113">
                Sientes un vacío en el estómago que parece un hambre física,
                pero ninguna comida lo llena. Solo se calmaría si él escribiera.
                Estás en un bucle de ansiedad total, y sabes que, si sigues así,
                vas a terminar enviando ese mensaje del que te vas a arrepentir
                mañana.
              </p>
            </div>

            <motion.a href="#oferta" className="inline-block bg-gradient-to-r from-[#c9a96e] to-[#d4a574] text-[#0f1629] font-semibold px-8 py-4 rounded-lg text-lg transition-all duration-300 hover:shadow-lg hover:shadow-[#c9a96e]/30 hover:scale-105" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.98
          }} data-id="element-114">
              ¡SÁCAME DE ESTE BUCLE AHORA!
            </motion.a>
          </motion.div>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative" data-id="element-115">
            <div className="relative" data-id="element-116">
              {/* Glow effect behind image */}
              <div className="absolute inset-0 bg-gradient-to-r from-[#c9a96e]/20 to-[#d4a574]/20 blur-3xl rounded-full transform scale-110" data-id="element-117" />
              <img src="https://cdn.magicpatterns.com/uploads/hkZqTGko2Eb4x1JbE7Yaov/heylloyd-image-1772237113722.png" alt="Breakup Blackout - Las Primeras 72 Horas - Dispositivos mostrando el producto" className="relative z-10 w-full h-auto rounded-lg shadow-2xl" data-id="element-118" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}